<template>
  <div>{{ props.name }} {{ t('checkout.NotSuppoted') }}</div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
import { onMounted } from 'vue'
import { useLogger } from 'vue-logger-plugin'
const props = defineProps<{ name: string; systemKeyword: string }>()
const logger = useLogger()

onMounted(() => {
  logger.debug('onMounted')
})
</script>
